<header class="myw-app-header myw-container myw-inner d-flex">
  <div class="myw-brand d-flex align-items-end">
    <img src="assets/images/logo.svg" alt="accenture" />
    <span style="font-weight: bold; color: darkblue;">GenWizard<sup>®</sup></span>
  </div>
  <div class="myw-header-nav d-flex justify-content-end">
    <!-- scope selector -->
    <div id="standScope" class="myw-header-item">
      <div class="myw-scope d-flex">
        <a href="javascript:;" class="myw-header-item dropdown-toggle" role="button" data-bs-display="static"
          data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false" id="scopeSelector"
          title="{{displayClient}} | {{displayProject}} | {{displayOpportunity}}"
          aria-label="Accenture - DCN Internal | Test Record">
          <span>{{displayClient}}</span>
          <span>{{displayProject}}</span>
          <span>{{displayOpportunity}}</span>
          <img src="assets/images/scope.svg" alt="" class="d-lg-none" />
        </a>
        <div class="dropdown-menu" #scopeSelectorId *ngIf='!scopeMySP' aria-labelledby="scopeSelector">
          <div id="loadScope" class="px-4 py-3">
            <!-- <div class="disp"> -->
            <div class="form-group">
              <label class="form-label">Client</label>
              <select name="selectClient" (change)="getEngagement($event)"
                class="form-control control-border rounded selectFilter" data-bs-target="engagement"
                [(ngModel)]="selectedClient">
                <option selected value="Select">Select</option>
                <option *ngFor="let client of ClientListFiltered" [selected]="client == selectedClient"
                  value="{{client}}">
                  {{client}}
                </option>
              </select>
            </div>
            <div class="form-group">
              <label class="form-label">Project</label>
              <select name="selectProject" (change)="getProject($event)"
                class="form-control control-border rounded engagement selectFilter" data-bs-target="opportunity"
                [(ngModel)]="selectedProject">
                <option selected value="Select">Select</option>
                <option *ngFor="let eng of ProjectListFiltered" [selected]="eng == selectedProject" value="{{eng}}">
                  {{eng}}
                </option>
              </select>
            </div>
            <div class="form-group">
              <label class="form-label">Opportunity Id</label>
              <select name="selectProposal" (change)="getProposal($event)"
                class="form-control control-border rounded opportunity selectFilter" [(ngModel)]="selectedOpportunity">
                <option selected value="Select">Select</option>
                <option *ngFor="let prop of ProposalListFiltered" [selected]="prop.ProposalName == selectedOpportunity"
                  value="{{prop.ProposalName}}">
                  {{prop.ProposalName}}
                </option>
              </select>
            </div>
            <!-- </div> -->
            <div>
              <button type="button" class="btn btn-primary" (click)="passOppId($event)"
                style="width: 7rem;">Apply</button>
            </div>
          </div>
        </div>
        <div class="dropdown-menu" *ngIf='scopeMySP' aria-labelledby="scopeSelector">
          <!-- <div class="disp"> -->
          <form class="px-4 py-3">
            <div class="form-group">
              <label class="form-label">Customer Relationship Name</label>
              <label class="form-control">{{mySPCustomer}}</label>
            </div>
            <div class="form-group">
              <label class="form-label">MMS Id - Opportunity Name</label>
              <label class="form-control">{{mySPOpportunity}}</label>
            </div>
            <div class="form-group">
              <label class="form-label">Solution Id - Service Group</label>
              <label class="form-control">{{mySPSolution}}</label>
            </div>
          </form>
          <!-- </div> -->
        </div>
      </div>
    </div>
    <!-- /scope selector -->
  <div *ngIf="envVar.Env != 'FDS_ManualUpload'" id="standaloneScope" class="myw-scope d-flex">
    <div *ngIf="flagforStandalone == true" class="myw-scope d-flex">
      <a *ngIf="this.sessionService.getClientName()" href="javascript:;" class="myw-header-item" role="button" style="cursor: default;"
        [title]="this.sessionService.getClientName() + ' | ' + this.sessionService.getDeliveryConstructName()">
        <span>{{this.sessionService.getClientName()}}</span>        
        <span>{{this.sessionService.getDeliveryConstructName()}}</span>
      </a>
    </div>
  </div>
    
    <!-- scope FDS selector -->
    <div *ngIf="loadFDSScope && envVar.Env == 'FDS_ManualUpload' && this.sessionService.getSessionStorageItem('userType') == '3'" class="myw-scope d-flex">
      <div class="dropdown dropright d-flex">
      <a href="javascript:;" class="myw-header-item dropdown-toggle" role="button" data-display="static"
          data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false" id="scopeSelector"
          [title]="this.sessionService.getClientName() + ' | ' + this.sessionService.getE2EDeliveryConstructName() + ' | ' + this.sessionService.getParentDeliveryConstructName() + ' | ' + this.sessionService.getDeliveryConstructName()"
          [attr.aria-label]="">
          <span>{{this.sessionService.getClientName()}}</span>
          <span>{{this.sessionService.getE2EDeliveryConstructName()}}</span>
          <span>{{this.sessionService.getParentDeliveryConstructName()}}</span>
          <span>{{this.sessionService.getDeliveryConstructName()}}</span>
          <img src="assets/images/scope.svg" alt="" class="d-lg-none" />
      </a>
      <div class="dropdown-menu" #fdsScopeSelectorId aria-labelledby="scopeSelector">
          <form class="d-flex flex-column h-100">
              <input type="hidden" name="CSRFToken" value="OWY4NmQwODE4ODRjN2Q2NTlhMmZlYWEwYzU1YWQwMTVhM2JmNGYxYjJiMGI4MjJjZDE1ZDZMGYwMGEwOA==">
              <div class="myw-scope-filter">
                  <input type="text" class="form-control"
                      placeholder="Enter minimum three characters to search..." />
              </div>
              <div class="myw-scope-list">
                  <!-- <tree [tree]="tree1"></tree> -->
                  <tree [tree]="tree" #treeComponent (nodeSelected)="onNodeSelected($event)"
                      (nodeExpanded)="onNodeExpanded($event)" [settings]="treeSettingsFDS">
                  </tree>
              </div>
              <div *ngIf="this.iomservice.IsAuthorized == true" class="myw-scope-footer d-flex ml-auto pt-3"
                  style="min-height: 39px;">
                  <button type="button" class="btn btn-primary" (click)="apply()" style="width: 7rem; margin-right: 1.5rem;margin-top: -11px;
      max-height: 30px;">Apply</button>
              </div>
          </form>
      </div>
      </div>
  </div>
    <div *ngIf="loadFDSScope && envVar.Env == 'SAAS_PAM'" class="myw-scope d-flex"> 
      <a href="javascript:;" class="myw-header-item" role="button"
        [title]="this.sessionService.getClientName() + ' | ' + this.sessionService.getE2EDeliveryConstructName() + ' | ' + this.sessionService.getParentDeliveryConstructName() + ' | ' + this.sessionService.getDeliveryConstructName()">
        <span
          (click)="loadDefaultPAMTree('00050000-0000-0000-0000-000000000000',false);">{{this.sessionService.getClientName()}}</span>
      </a>
      <div class="dropdown dropright d-flex">
        <a href="javascript:;" class="myw-header-item dropdown-toggle" role="button" data-display="static"
          data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false" id="scopeSelector"
          [title]="this.sessionService.getClientName() + ' | ' + this.sessionService.getE2EDeliveryConstructName() + ' | ' + this.sessionService.getParentDeliveryConstructName() + ' | ' + this.sessionService.getDeliveryConstructName()"
          [attr.aria-label]="">
          <span>&nbsp;</span>
          <span
            *ngIf="this.sessionService.getE2EDeliveryConstructName()">{{this.sessionService.getE2EDeliveryConstructName()}}</span>
          <span
            *ngIf="this.sessionService.getParentDeliveryConstructName()">{{this.sessionService.getParentDeliveryConstructName()}}</span>
          <span
            *ngIf="this.sessionService.getDeliveryConstructName()">{{this.sessionService.getDeliveryConstructName()}}</span>
          <img src="assets/images/scope.svg" alt="" class="d-lg-none" />
        </a>
        <div class="dropdown-menu dropdown-md" #fdsScopeSelectorId aria-labelledby="scopeSelector">
          <form class="d-flex flex-column h-100">
            <!-- <div class="myw-scope-filter">
              <input type="text" class="form-control"
                  placeholder="Enter minimum three characters to search..." />
          </div> -->
            <div *ngIf="iomservice.isManualUpload == false" class="form-group mx-2 my-2"> 
              <select name="selectPAMClient" id="selectPAMClient" [ngClass]="{'selectedDCBackGround': dsSelected }"
                class="form-control control-border rounded selectFilter" [(ngModel)]="selectedPAMClientUId"
                (change)="loadDefaultPAMTree(selectedPAMClientUId,true);">
                <option *ngFor="let client of PAMClient"
                  [selected]="client.DeliveryConstructUId == selectedPAMClientUId"
                  value="{{client.DeliveryConstructUId}}">
                  {{client.DeliveryConstruct}}
                </option>
              </select>
            </div>
            <div class="myw-scope-list"> 
              <!-- <tree [tree]="tree1"></tree> -->
              <tree *ngIf="iomservice.isManualUpload == false" [tree]="tree" #treeComponent (nodeSelected)="onNodeSelected($event)"
                (nodeExpanded)="onNodeExpanded($event)" [settings]="treeSettings">
              </tree>
              <tree *ngIf="iomservice.isManualUpload == true && flagforStandalone == false" [tree]="tree" #treeComponent (nodeSelected)="onNodeSelected($event)"
              (nodeExpanded)="onNodeExpanded($event)" [settings]="treeSettingsFDS">
            </tree>
            </div>
            <div *ngIf="iomservice.IsAuthorized == true && flagforStandalone == false" class="myw-scope-footer d-flex ml-auto pt-3"
              style="min-height: 39px;">
              <button type="button" class="btn btn-primary" (click)="apply()" style="width: 7rem; margin-right: 1.5rem;margin-top: -11px;
            max-height: 30px;">Apply</button>
            </div>
          </form>
        </div>
      </div>
    </div>  
  
    <!-- /FDS scope selector -->
    <div class="dropdown dropright dropflat d-flex">
      <a href="javascript:;" class="myw-header-item dropdown-toggle myw-help" role="button" data-bs-display="static"
        data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false" id="help" title="Help">
        <img src="assets/images/help.svg" alt="Help" />
        <span class="sr-only">Help</span>
      </a>
      <div class="dropdown-menu" aria-labelledby="help">
        <a class="dropdown-item" href="javascript:;" download="IOM User Manual.pdf"
          title="Click here to download" (click)="userManul()">IOM User Manual</a>
          <!-- <a class="dropdown-item" href="./assets/Template/User_Manual.pdf" download="IOM User Manual.pdf"
          title="Click here to download" (click)="userManul()">IOM User Manual</a> -->
        <a style="display: none;" *ngIf="envVar.instanceType == 'FDS'" class="dropdown-item" target="_blank" rel="noreferrer noopener"
          href="https://kxdocuments.accenture.com/contribution/c4f01cb9-79f0-4b75-a1ff-923b16a493fd">
          KXDocuments Link
        </a>
      </div>
    </div>
    <div *ngIf="LoggedInUser" class="dropdown dropright d-flex" style="white-space: nowrap;">
      <a href="javascript:;" class="myw-login myw-header-item dropdown-toggle" role="button" data-bs-display="static"
        data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false" id="loginDetails" title="{{LoggedInUser}}">
        <img src="assets/images/user.svg" alt="{{LoggedInUser}}" />
        <span class="sr-only">{{LoggedInUser}}</span>
      </a>
      <div class="dropdown-menu dropdown-md" aria-labelledby="loginDetails">
        <div class="dropdown-body iom-user">
          <div class="p-3">
            <p>
              Welcome,
              <strong> {{LoggedInUser}}</strong>
            </p>
            <button type="button" (click)="LogOut()" class="btn btn-primary">Logout</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</header>
<!-- /header -->
<!-- topbar -->
<div class="myw-topbar" *ngIf="!hideTopBar()">
  <div class="myw-inner myw-container d-flex flex-wrap">
    <a href="javascript:;" (click)="navigateToHome()" class="myw-app-name d-flex align-items-center"
      [class.disabled]="hideScopeSelectorinLogout()">
      Intelligent Opportunity Miner
    </a>
  </div>
</div>
<!-- /topbar -->

<div *ngIf='accessDeniedMessageShow'>
  <app-access-denied></app-access-denied>
</div>
<div *ngIf='errorOccured'>
  <app-error></app-error>
</div>